
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { AuthenticationService } from './authentication.service';
import { Baseservice } from './baseservice';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class CarrierTypeDocumentService extends Baseservice {

  constructor(http: HttpClient, authentication: AuthenticationService) {
    super('carriertypedocument', http, authentication);
  }
  get() {
    return this.getCarrierTypeDocument(this.url + "/documenttype");
  }

  getCarrierTypeDocument(url: string) {
    return this.getRequest(url).pipe(map(response => response));
  }

}
